import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getTextCardElements } from './helpers';
import Button from '../../../../../../../../../../../../components/global/Button';
import withModal from '../../../../../../../../../../../../components/global/modal/withModal';

const propTypes = {
  className: PropTypes.string,
  actionProps: PropTypes.shape({
    accountCard: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    onComplete: PropTypes.func.isRequired,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const AccountCardEmptyTextAlertModal = ({
  className,
  actionProps,
  onRequestClose,
}) => {
  const { accountCard, onComplete } = actionProps;
  const classes = classNames({
    'print-product-mounting-options-alert': true,
    [className]: !!className,
  });
  const missingElements = getTextCardElements({ accountCard, emptyOnly: true });

  return (
    <div className={classes}>
      <h4 className="text-center">Woah!</h4>
      <p>Looks like you didn&apos;t complete the following fields:</p>
      <ul className="account-card-empty-field-list">
        {missingElements.map(cardElement => {
          const elementConfig = accountCard.account_card_sides[0].card_side.card_element_configurations.find(
            config => config.card_element.id === cardElement.id,
          );

          return (
            <li key={elementConfig?.id} className="text-capitalize text-bold">
              {elementConfig?.help_placeholder.toLowerCase()}
            </li>
          );
        })}
      </ul>

      <Button btnBlock btnOutline onClick={onRequestClose}>
        Return to complete
      </Button>
      <Button
        btnBlock
        onClick={() => {
          onComplete();
          onRequestClose();
        }}
      >
        I&apos;m good, please leave blank
      </Button>
    </div>
  );
};

AccountCardEmptyTextAlertModal.propTypes = propTypes;

export const ACCOUNT_CARD_EMPTY_TEXT_ALERT_MODAL =
  'ACCOUNT_CARD_EMPTY_TEXT_ALERT_MODAL';

export default withModal(AccountCardEmptyTextAlertModal, {
  name: ACCOUNT_CARD_EMPTY_TEXT_ALERT_MODAL,
  dismissible: false,
  hideHeader: true,
  size: 'sm',
});
